module.exports = "/assets/735f80252f5efbfea5984b8bd941fce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/M9.png
// module id = 1606
// module chunks = 0